import { render, staticRenderFns } from "./order-disapprove-modal.vue?vue&type=template&id=d830df26"
import script from "./order-disapprove-modal.vue?vue&type=script&lang=js"
export * from "./order-disapprove-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports